import { render, staticRenderFns } from "./AlertBase.vue?vue&type=template&id=19c8c1be&scoped=true&lang=pug&"
import script from "./AlertBase.vue?vue&type=script&lang=js&"
export * from "./AlertBase.vue?vue&type=script&lang=js&"
import style0 from "./AlertBase.vue?vue&type=style&index=0&id=19c8c1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c8c1be",
  null
  
)

export default component.exports